
import "./KudosCard.css";
import AddBlockerButton from "../addBlockerButton/AddBlockerButton";
import AddKudosButton from "../addKudosButton/AddKudosButton";
import AddFeedbackButton from "../addFeedbackButton/AddFeedbackButton";
import { Button } from "primereact/button";

function KudosCard({ onKudosCreated, onOpenRecentKudos }) {
  return (
    <div className="summary-kudos-card">
      <div className="summary-kudos-header">
        <div>
          <i className="pi pi-star" />
          <h4>Recognition & Feedback</h4>
        </div>
      </div>

      <div className="summary-kudos-body">
        <p className="summary-kudos-description">
          Recognize your teammates, share feedback, or raise a blocker.
        </p>

        <div className="summary-kudos-actions">
          <AddBlockerButton />
          <AddKudosButton onCreated={onKudosCreated} />
          <AddFeedbackButton />
          <Button
            type="button"
            label="Open Recent Kudos"
            icon="pi pi-star"
            outlined
            className="summary-kudos-open-button"
            onClick={onOpenRecentKudos}
          />
        </div>
      </div>
    </div>
  );
}

export default KudosCard;
